/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React, { useEffect, useState } from 'react';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
import { Grid, IconButton, Menu, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, styled } from '@mui/material';
import type { TableColumn } from 'react-data-table-component';
import MUIModal from '../MUIModal/MUIModal';
import { ARE_YOU_SURE, LABEL_BTN_CANCEL, UNSUBSCRIBE_EMAIL_SUCCESS, UNKNOWN_ERR, BULK_UNSUBSCRIBE_LEVELS, UNSUBSCRIBE_EMAIL_FAILURE } from 'src/constants/constant';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';
import type { RootState } from '../types/types';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { MoreVerticalSolidRounded } from '@hugeicons-pro/core-solid-rounded';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
import type { UnsubscribeListType, Client, appConfigs } from '../types/types';
import { getAllUnsubscribeEmail, removeEmailsFromUnsubscribeList, importUnsubscribeList, exportUnsubscribeList, downloadImportTemplate } from 'src/services/unsubscribeService';
import { TextareaAutosize, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, InputLabel, Button, Box, CircularProgress, Link, Autocomplete, TextField } from '@mui/material';
import moment from 'moment';
import { checkEventPermission } from "../../common/utility/utility";
import GradientButton from '../MUICustomButton/GradientButton';
import OutlineButton from '../MUICustomButton/OutlineButton';
import { getAllClientData } from 'src/services/clientService';
import { getAllCampaigns } from 'src/services/campaignService';
import { getAllBulkEmail } from 'src/services/bulkEmailServices';
// @ts-ignore
import { Download04Icon, Upload04Icon, ArrowDown01Icon } from '@hugeicons-pro/core-stroke-standard';
//@ts-ignore
import { MultiplicationSignStrokeStandard, Alert02StrokeStandard } from '@hugeicons-pro/core-stroke-standard';
import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import CsvService from 'src/services/dataExport.service';

const ITEM_HEIGHT = 48;

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

interface ApiResponse {
  status: number;
  data: {
    data: UnsubscribeListType[];
    result: number;
  };
}

interface CampaignList {
  campaignId: number;
  name: string;
}

const UnSubscribeList: React.FC = () => {

  const [unsubscribeData, setUnsubscribeData] = useState<UnsubscribeListType[]>([]);
  const [unsubscribeSearchData, setUnsubscribeSearchData] = useState<UnsubscribeListType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [unsubscribeEmailData, setUnsubscribeEmailData] = useState<UnsubscribeListType | null>(null);
  const [showDeleteUnsubscribeModal, setShowDeleteUnsubscribeModal] = useState<boolean>(false);
  const [submitmessage, setSubmitMessage] = useState('');
  const [validationError, setValidationError] = useState('');
  const [warningMessage, setWarningMessage] = useState('');
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [anchorActionEl, setAnchorActionEl] = useState<Record<string, HTMLElement | null>>({});
  const { user } = useSelector((state: RootState) => state.auth);

  // Import/Export States
  const [showImportModal, setShowImportModal] = useState<boolean>(false);
  const [showExportModal, setShowExportModal] = useState<boolean>(false);
  const [importScope, setImportScope] = useState<string>('Client');
  const [exportScope, setExportScope] = useState<string>('Client');
  const [selectedImportClient, setSelectedImportClient] = useState<number | string>(user?.isClientRole && user?.clientId ? Number(user.clientId) : '');
  const [selectedExportClient, setSelectedExportClient] = useState<number | string>(user?.isClientRole && user?.clientId ? Number(user.clientId) : '');
  const [selectedImportCampaign, setSelectedImportCampaign] = useState<number | string>('');
  const [selectedExportCampaign, setSelectedExportCampaign] = useState<number | string>('');
  const [clients, setClients] = useState<Client[]>([]);
  const [importCampaigns, setImportCampaigns] = useState<CampaignList[]>([]);
  const [exportCampaigns, setExportCampaigns] = useState<CampaignList[]>([]);
  const [importFile, setImportFile] = useState<File | null>(null);
  const [isImportLoading, setIsImportLoading] = useState<boolean>(false);
  const [isExportLoading, setIsExportLoading] = useState<boolean>(false);
  const [importErrorSummary, setImportErrorSummary] = useState<string | null>(null);
  const [importErrorDetails, setImportErrorDetails] = useState<{ row: number; reason: string }[]>([]);
  const [importEmailType, setImportEmailType] = useState<string>('');
  const [exportEmailType, setExportEmailType] = useState<string>('');
  const [MaxRequestBodySizeData, setMaxRequestBodySizeData] = useState<string>('');

  const getUnsubscribeType = (scope: string): number => {
    return Number(BULK_UNSUBSCRIBE_LEVELS.find(l => l.label === scope)?.value ?? '1');
  };




  useEffect(() => {
    const storedAppConfig = localStorage.getItem("appConfigs");
    if (storedAppConfig) {
      try {
        const parsedAppConfig = JSON.parse(storedAppConfig) as appConfigs[];
        const maxRequestBodySize = parsedAppConfig.find(
          (item) => item.configName === "MaxRequestBodySize"
        )?.configValue;
        if (maxRequestBodySize) {
          setMaxRequestBodySizeData(maxRequestBodySize);
        }
      } catch (error) {
        console.error("Error parsing appConfig data:", error);
      }
    }
    getUnsubscribeListData();
    fetchClients();
  }, [user]);

  useEffect(() => {
    if (showImportModal && selectedImportClient && importEmailType) {
      fetchCampaigns(Number(selectedImportClient), 'import', importEmailType);
    } else {
      setImportCampaigns([]);
    }
  }, [showImportModal, selectedImportClient, importEmailType]);

  useEffect(() => {
    if (showExportModal && selectedExportClient && exportEmailType) {
      fetchCampaigns(Number(selectedExportClient), 'export', exportEmailType);
    } else {
      setExportCampaigns([]);
    }
  }, [showExportModal, selectedExportClient, exportEmailType]);

  const fetchClients = async (): Promise<void> => {
    try {
      // const roleId = user?.roleID; 
      // const res = await getAllClientData(roleId);
      const res = await getAllClientData();
      if (res.status === 200 && res.data.result === 1) {
        setClients(res.data.data);
      }
    } catch (error) {
      console.error('Failed to fetch clients:', error);
    }
  };

  const handleImportEmailTypeChange = (emailType: string): void => {
    setImportEmailType(emailType);
    setSelectedImportCampaign('');
    setImportCampaigns([]);
    // If client already selected and scope is Campaign, fetch immediately
    if (importScope === 'Campaign' && selectedImportClient) {
      fetchCampaigns(Number(selectedImportClient), 'import', emailType);
    }
  };

  const handleExportEmailTypeChange = (emailType: string): void => {
    setExportEmailType(emailType);
    setSelectedExportCampaign('');
    setExportCampaigns([]);
    // If client already selected and scope is Campaign, fetch immediately
    if (exportScope === 'Campaign' && selectedExportClient) {
      fetchCampaigns(Number(selectedExportClient), 'export', emailType);
    }
  };

  // Pass emailType explicitly as a parameter
  const fetchCampaigns = async (clientId: number, type: 'import' | 'export', emailType: string): Promise<void> => {
    try {
      console.log('Fetching campaigns for:', { clientId, type, emailType });

      let normalizedCampaigns: CampaignList[] = [];

      if (emailType === 'TriggerRequest') {
        const res = await getAllCampaigns(clientId);
        console.log('TriggerEmail API response:', res);

        if (res.status === 200 && res.data?.result === 1) {
          // The data is directly in res.data.data array
          const campaigns = res.data.data || [];
          console.log('Raw campaigns data:', campaigns);

          normalizedCampaigns = campaigns.map((camp: any) => ({
            campaignId: camp.bulkCampaignId || camp.campaignId || camp.id,
            name: camp.bulkCampaignName || camp.campaignName || camp.name || ''
          }));
        }
      } else if (emailType === 'BulkCampaign') {
        const res = await getAllBulkEmail(clientId);
        console.log('BulkEmail API response:', res);

        if (res.status === 200 && res.data?.result === 1) {
          // The data is directly in res.data.data array
          const campaigns = res.data.data || [];
          console.log('Raw bulk emails data:', campaigns);

          normalizedCampaigns = campaigns.map((camp: any) => ({
            campaignId: camp.bulkCampaignId || camp.campaignId || camp.id,
            name: camp.bulkCampaignName || camp.campaignName || camp.name || ''
          }));
        }
      }

      console.log('Normalized campaigns:', normalizedCampaigns);

      if (type === 'import') {
        setImportCampaigns(normalizedCampaigns);
      } else {
        setExportCampaigns(normalizedCampaigns);
      }
    } catch (error) {
      console.error('Failed to fetch campaigns:', error);
    }
  };

  const getUnsubscribeListData = (): void => {
    setLoading(true);
    const ClientId = user?.clientId ? Number(user.clientId) : 0;
    getAllUnsubscribeEmail(ClientId)
      .then((res: ApiResponse) => {
        if (res.status === 200 && res.data.result === 1) {
          setUnsubscribeData(res.data.data ? res.data.data : []);
          setUnsubscribeSearchData(res.data.data ? res.data.data : []);
        } else {
          setUnsubscribeData([]);
          setUnsubscribeSearchData([]);
        }
      })
      .catch((error) => {
        console.error('Failed to load unsubscribe list:', error);
      })
      .finally(() => setLoading(false));
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.target.value.trim();
    let unsubscribeDataArr = [...unsubscribeData]
    if (value !== "") {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-optional-chain
      unsubscribeDataArr = unsubscribeDataArr && unsubscribeDataArr.filter((unsubscribe: UnsubscribeListType) => {
        return unsubscribe.emailAddress.toLowerCase().search(value.toLowerCase()) >= 0
      })
    }
    setUnsubscribeSearchData(unsubscribeDataArr)
  }

  const handleActionClick = (event: React.MouseEvent<HTMLElement>, email: string): void => {
    setAnchorActionEl({ ...anchorActionEl, [email]: event.currentTarget });
  };

  const handleDeleteUnsubscribeEmail = (row: UnsubscribeListType): void => {
    setUnsubscribeEmailData(row);
    setShowDeleteUnsubscribeModal(true);
    setAnchorActionEl({ ...anchorActionEl, [row.emailAddress]: null });
  };


  const handleDeleteUnsubscribeClose = (): void => {
    setSubmitMessage('');
    setValidationError('');
    setWarningMessage('');
    setShowDeleteUnsubscribeModal(false);
  };

  const handleDeleteUnsubscribeConfirm = async (): Promise<void> => {
    if (!submitmessage.trim()) {
      setValidationError("Please provide a reason for deletion.");
      return;
    }

    setIsModalLoading(true);

    try {
      const payload = {
        emailAddress: unsubscribeEmailData?.emailAddress ?? '',
        clientId: unsubscribeEmailData?.clientId ?? 0,
        campaignId: unsubscribeEmailData?.campaignId ?? 0,
        campaignType: unsubscribeEmailData?.campaignType ?? '',
        unsubscribeTypeId: unsubscribeEmailData?.unsubscribeTypeId ?? 0,
        reason: submitmessage,
        userId: user?.id ?? 0
      };
      const res = await removeEmailsFromUnsubscribeList(payload);

      if (res?.data?.result === 1) {
        NotificationManager.success(UNSUBSCRIBE_EMAIL_SUCCESS, "", 5000);

        setShowDeleteUnsubscribeModal(false);
        getUnsubscribeListData();
      }
      else {
        setShowDeleteUnsubscribeModal(false);
        NotificationManager.error(UNSUBSCRIBE_EMAIL_FAILURE, "", 5000);
      }

    } catch (error) {
      console.log("Delete Error", error);

      NotificationManager.error(UNKNOWN_ERR, "", 5000);

    } finally {
      setIsModalLoading(false);
    }
  };

  const handleDownloadTemplate = async (): Promise<void> => {
    try {
      const response = await downloadImportTemplate();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'unsubscribe_template.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Template Download Error', error);
      NotificationManager.error('Failed to download template', "", 5000);
    }
  };

  const mbValue = MaxRequestBodySizeData ? Math.round(parseInt(MaxRequestBodySizeData) / 1024 / 1024) : 0;

  const onDrop = useCallback(
    (acceptedFiles: any, rejectedFiles: any) => {
      if (rejectedFiles.length > 0) {
        NotificationManager.error("Please select a valid CSV file", "", 5000);
      } else {
        const file = acceptedFiles[0];
        if (!file) return;

        if (MaxRequestBodySizeData !== "" && file.size > parseInt(MaxRequestBodySizeData)) {
          NotificationManager.error(`File size must be less than ${mbValue} MB`, "", 5000);
          return;
        }
        if (file.name.split(".").pop()?.toLowerCase() !== "csv") {
          NotificationManager.error("The file must be in CSV format.", "", 5000);
          return;
        }

        setImportErrorSummary(null);
        setImportErrorDetails([]);
        setImportFile(file);
      }
    },
    [MaxRequestBodySizeData, mbValue]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "text/csv": [".csv"] },
    maxFiles: 1,
  });

  const handleRemoveFile = (): void => {
    setImportFile(null);
    setImportErrorSummary(null);
    setImportErrorDetails([]);
  };

  const handleImport = async (): Promise<void> => {
    if (!importEmailType) {
      NotificationManager.error('Please select an email type.', "", 5000);
      return;
    }
    if ((importScope === 'Client' || importScope === 'Campaign') && !selectedImportClient) {
      NotificationManager.error('Please select a client.', "", 5000);
      return;
    }
    if (importScope === 'Campaign' && !selectedImportCampaign) {
      NotificationManager.error('Please select a campaign.', "", 5000);
      return;
    }
    if (!importFile) {
      NotificationManager.error('Please select a file to import.', "", 5000);
      return;
    }

    setIsImportLoading(true);
    setImportErrorSummary(null);
    setImportErrorDetails([]);

    try {
      const formData = new FormData();
      formData.append('file', importFile);

      const queryParams: Record<string, unknown> = {
        unsubscribeType: getUnsubscribeType(importScope),
        emailType: importEmailType,
        userId: user?.id ?? 0,
      };

      if (importScope === 'Global') {
        queryParams.clientId = user?.clientId ? Number(user.clientId) : 0;
      } else {
        if (selectedImportClient) queryParams.clientId = selectedImportClient;
      }
      if (selectedImportCampaign) queryParams.campaignId = selectedImportCampaign;

      const res = await importUnsubscribeList(formData, queryParams);

      if (res.data.result === 1) {
        const rawMsg: string = typeof res.data.messages === 'string' ? res.data.messages : '';
        const msgLower = rawMsg.toLowerCase();

        if (msgLower.includes('upload summary')) {
          const total = rawMsg.match(/Total Emails:\s*(\d+)/i)?.[1] ?? '0';
          const inserted = Number(rawMsg.match(/Inserted:\s*(\d+)/i)?.[1] ?? '0');
          const invalid = Number(rawMsg.match(/Invalid:\s*(\d+)/i)?.[1] ?? '0');
          const existing = Number(rawMsg.match(/Already Exists?:\s*(\d+)/i)?.[1] ?? '0');
          const duplicate = Number(rawMsg.match(/Duplicate:\s*(\d+)/i)?.[1] ?? '0');

          const summaryParts = [`Upload Summary: Total Emails: ${total}`];
          if (invalid > 0) summaryParts.push(`Invalid: ${invalid}`);
          if (duplicate > 0) summaryParts.push(`Duplicate: ${duplicate}`);
          if (existing > 0) summaryParts.push(`Already Exists: ${existing}`);
          summaryParts.push(`Inserted: ${inserted}`);

          const finalMessage = summaryParts.join(', ');
          const skipped = invalid + existing + duplicate;

          if (skipped > 0 && inserted > 0) {
            NotificationManager.success(finalMessage, "", 6000);
          } else if (inserted > 0) {
            NotificationManager.success(finalMessage, "", 5000);
          } else if (skipped > 0) {
            NotificationManager.error(finalMessage, "", 5000);
          } else {
            NotificationManager.success(finalMessage, "", 5000);
          }

          setShowImportModal(false);
          getUnsubscribeListData();
          resetImportState();
        } else if (msgLower.includes('already exist')) {
          NotificationManager.error('Some emails already exist in the unsubscribe list.', "", 5000);
          setShowImportModal(false);
          getUnsubscribeListData();
          resetImportState();
        } else if (msgLower.includes('invalid') || msgLower.includes('failed')) {
          // Backend returned result=1 but with an error message
          NotificationManager.error('Import failed due to invalid data. Please check your file.', "", 5000);
        } else {
          // Clean success
          const match = rawMsg.match(/\d+/);
          const count = match ? match[0] : '';
          const successMessage = count
            ? `${count} emails imported successfully.`
            : 'Unsubscribe list imported successfully.';

          NotificationManager.success(successMessage, "", 5000);
          setShowImportModal(false);
          getUnsubscribeListData();
          resetImportState();
        }
      } else {
        // Map long backend messages to short ones
        const rawMsg: string = typeof res.data.messages === 'string' ? res.data.messages.toLowerCase() : '';
        let shortMsg = 'Import failed. Please try again.';

        if (rawMsg.includes('invalid file')) {
          shortMsg = 'Invalid file. Please upload a valid CSV file.';
        } else if (rawMsg.includes('email') && rawMsg.includes('column')) {
          shortMsg = "File must contain an 'Email' column.";
        } else if (rawMsg.includes('at least one')) {
          shortMsg = 'File must contain at least one valid email address.';
        } else if (rawMsg.includes('blob') || rawMsg.includes('folder')) {
          shortMsg = 'Server configuration error. Please contact support.';
        }

        NotificationManager.error(shortMsg, "", 5000);
      }
    } catch (error: any) {
      console.error('Import Error', error);
      const rawMsg: string = (error.response?.data?.messages ?? '').toLowerCase();
      let shortMsg = 'Import failed. Please try again.';

      if (rawMsg.includes('unsubscribe type')) {
        shortMsg = 'Please select a valid unsubscribe type.';
      } else if (rawMsg.includes('clientid')) {
        shortMsg = 'Please select a client.';
      } else if (rawMsg.includes('campaignid')) {
        shortMsg = 'Please select a campaign.';
      } else if (rawMsg.includes('emailtype')) {
        shortMsg = 'Please select an email type.';
      } else if (rawMsg.includes('userid')) {
        shortMsg = 'Invalid user session. Please log in again.';
      } else if (rawMsg.includes('invalid file')) {
        shortMsg = 'Invalid file. Please upload a valid CSV file.';
      }

      NotificationManager.error(shortMsg, "", 5000);
    } finally {
      setIsImportLoading(false);
    }
  };

  const handleExport = async (): Promise<void> => {
    if ((exportScope === 'Client' || exportScope === 'Campaign') && !selectedExportClient) {
      NotificationManager.error('Please select a client.', "", 5000);
      return;
    }
    if (exportScope === 'Campaign' && !selectedExportCampaign) {
      NotificationManager.error('Please select a campaign.', "", 5000);
      return;
    }

    setIsExportLoading(true);

    try {
      const params: Record<string, any> = {
        unsubscribeType: getUnsubscribeType(exportScope),
      };

      if (exportScope === 'Global') {
        params.clientId = user?.clientId ? Number(user.clientId) : 0;
      } else {
        if (selectedExportClient) params.clientId = selectedExportClient;
      }
      if (selectedExportCampaign) params.campaignId = selectedExportCampaign;

      const res = await exportUnsubscribeList(params);

      let records: any[] = [];
      let responseData = res.data;

      if (res.data instanceof Blob) {
        try {
          const text = await res.data.text();
          responseData = JSON.parse(text);
        } catch (e) {
          // failed to parse
        }
      }

      if (Array.isArray(responseData)) {
        records = responseData;
      } else if (responseData?.result === 1 && Array.isArray(responseData?.data)) {
        records = responseData.data; // ✅ Matches: { result: 1, data: [...] }
      }

      if (records.length > 0) {
        const data: any[] = records.map((record: any) => {
          const unsubscribedOnRaw = record.unsubscribeOn ?? null;
          const unsubscribedOnDate =
            !unsubscribedOnRaw
              ? moment().format("MM/DD/YYYY")
              : moment(unsubscribedOnRaw).format("MM/DD/YYYY");

          return {
            "Email": record.email ?? '',
            "Unsubscribed On": unsubscribedOnDate,
          };
        });

        const timestamp = moment().format('YYYYMMDD');
        let filename = `unsubscribe_${exportScope.toLowerCase()}_${timestamp}.csv`;

        if (exportScope === 'Client') {
          const clientName = clients.find(c => c.id === selectedExportClient)?.clientName ?? 'client';
          filename = `unsubscribe_${clientName}_${timestamp}.csv`;
        } else if (exportScope === 'Campaign') {
          const clientName = clients.find(c => c.id === selectedExportClient)?.clientName ?? 'client';
          const campaignName = exportCampaigns.find(c => c.campaignId === selectedExportCampaign)?.name ?? 'campaign';
          filename = `unsubscribe_${clientName}_${campaignName}_${timestamp}.csv`;
        }

        const csvData = CsvService.jsonToCsv(data);
        CsvService.downloadCsvFile(csvData, filename);

        setShowExportModal(false);
        resetExportState();
      } else {
        NotificationManager.error('No records found for the selected criteria.', "", 5000);
      }
    } catch (error: any) {
      console.error('Export Error', error);
      const rawMsg: string = (error.response?.data?.messages ?? '').toLowerCase();
      let shortMsg = 'Export failed. Please try again.';

      if (rawMsg.includes('unsubscribe type')) shortMsg = 'Please select a valid unsubscribe type.';
      else if (rawMsg.includes('clientid')) shortMsg = 'Please select a client.';
      else if (rawMsg.includes('campaignid')) shortMsg = 'Please select a campaign.';

      NotificationManager.error(shortMsg, "", 5000);
    } finally {
      setIsExportLoading(false);
    }
  };

  const resetImportState = (): void => {
    setImportFile(null);
    setImportScope('Client');
    setSelectedImportClient(user?.isClientRole && user?.clientId ? Number(user.clientId) : '');
    setSelectedImportCampaign('');
    setImportEmailType('');
    setImportErrorSummary(null);
    setImportErrorDetails([]);
  };

  const resetExportState = (): void => {
    setExportScope('Client');
    setSelectedExportClient(user?.isClientRole && user?.clientId ? Number(user.clientId) : '');
    setSelectedExportCampaign('');
    setExportEmailType('');
  };

  const handleImportScopeChange = (scope: string): void => {
    setImportScope(scope);
    setSelectedImportClient(user?.isClientRole && user?.clientId ? Number(user.clientId) : '');
    setSelectedImportCampaign('');
    setImportEmailType('');
    setImportFile(null);
    setImportErrorSummary(null);
    setImportErrorDetails([]);
  };

  const handleExportScopeChange = (scope: string): void => {
    setExportScope(scope);
    setSelectedExportClient(user?.isClientRole && user?.clientId ? Number(user.clientId) : '');
    setSelectedExportCampaign('');
    setExportEmailType('');
  };



  const columns: TableColumn<UnsubscribeListType>[] = [
    {
      name: 'Email',
      selector: (row) => row.emailAddress,
      width: '20%',
      wrap: true,
      sortable: true,
      cell: (row) => (
        <div className="flex py-4" style={{ width: '100%' }}>
          <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted w-full">
            <CustomTooltip title={row.emailAddress} placement="bottom" arrow={false}>
              <p className="overflow-hidden text-ellipsis whitespace-nowrap w-full">{row.emailAddress}</p>
            </CustomTooltip>
          </div>
        </div>
      )
    },
    {
      name: 'Client',
      selector: (row) => row.clientName,
      width: '15%',
      wrap: true,
      sortable: true,
      cell: (row) => (
        <div className="flex py-4" style={{ width: '100%' }}>
          <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted w-full">
            <CustomTooltip title={row.clientName} placement="bottom" arrow={false}>
              <p className="overflow-hidden text-ellipsis whitespace-nowrap w-full">{row.clientName}</p>
            </CustomTooltip>
          </div>
        </div>
      )
    },
    {
      name: 'Campaign',
      selector: (row) => row.campaignName,
      width: '15%',
      wrap: true,
      sortable: true,
      cell: (row) => (
        <div className="flex py-4" style={{ width: '100%' }}>
          <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted w-full">
            <CustomTooltip title={row.campaignName} placement="bottom" arrow={false}>
              <p className="overflow-hidden text-ellipsis whitespace-nowrap w-full">{row.campaignName}</p>
            </CustomTooltip>
          </div>
        </div>
      )
    },
    {
      name: 'Unsubscribed On',
      selector: (row: any) => (!row.unsubscribedOn) ? moment().format("MM/DD/YYYY") : moment(row.unsubscribedOn).format("MM/DD/YYYY"),
      width: '15%',
      sortable: true,
      cell: (row) => {
        const displayDate = (!row.unsubscribedOn) ? moment().format("MM/DD/YYYY") : moment(row.unsubscribedOn).format("MM/DD/YYYY");
        return (
          <div className="flex py-4" style={{ width: '100%' }}>
            <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted w-full">
              <CustomTooltip title={displayDate} placement="bottom" arrow={false}>
                <p className="overflow-hidden text-ellipsis whitespace-nowrap w-full">{displayDate}</p>
              </CustomTooltip>
            </div>
          </div>
        );
      }
    },
    {
      name: 'Unsubscribe Type',
      selector: (row) => row.unsubscribeTypeId,
      width: '15%',
      sortable: true,
      cell: (row) => {
        const match = BULK_UNSUBSCRIBE_LEVELS.find(
          (item) => item.value === String(row.unsubscribeTypeId)
        );
        const label = match?.label ?? "";

        return (
          <div className="flex py-4" style={{ width: '100%' }}>
            <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted w-full">
              <CustomTooltip title={label} placement="bottom" arrow={false}>
                <p className="overflow-hidden text-ellipsis whitespace-nowrap w-full">
                  {label}
                </p>
              </CustomTooltip>
            </div>
          </div>
        );
      }
    },
    {
      name: 'Campaign Type',
      selector: (row) => row.campaignType,
      width: '10%',
      sortable: true,
      cell: (row) => (
        <div className="flex py-4" style={{ width: '100%' }}>
          <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted w-full">
            <CustomTooltip title={row.campaignType} placement="bottom" arrow={false}>
              <p className="overflow-hidden text-ellipsis whitespace-nowrap w-full">{row.campaignType}</p>
            </CustomTooltip>
          </div>
        </div>
      )
    },
    {
      name: 'Actions',
      width: '10%',
      center: true,
      cell: (row) => (
        <div className="flex items-center">

          {checkEventPermission('UNSUBSCRIBELIST_DELETE') && (
            <>
              <IconButton onClick={(e) => handleActionClick(e, row.emailAddress)}>
                <HugeiconsIcon
                  icon={MoreVerticalSolidRounded}
                  size={24}
                  color="#3A3A3A"
                  strokeWidth={0.2}
                />
              </IconButton>

              <Menu
                id={`menu-${row.emailAddress}`}
                className="table-action-menu"
                anchorEl={anchorActionEl[row.emailAddress]}
                open={Boolean(anchorActionEl[row.emailAddress])}
                onClose={() =>
                  setAnchorActionEl({ ...anchorActionEl, [row.emailAddress]: null })
                }
                slotProps={{
                  paper: {
                    style: {
                      maxHeight: ITEM_HEIGHT * 4.5,
                      width: "16ch",
                    },
                  }
                }}
              >
                <MenuItem onClick={() => handleDeleteUnsubscribeEmail(row)}>
                  <span style={{ paddingLeft: "15px", color: "#F13139" }}>
                    Delete
                  </span>
                </MenuItem>
              </Menu>
            </>
          )}

        </div>
      )
    }

  ];

  return (
    <>
      <h2 className="text-2xl font-semibold text-title">Unsubscribe List</h2>
      <div className="mt-[20px] mb-[20px]">
        <Grid container spacing={2} alignItems={'center'}>
          <Grid item xs={12} sm={6} md={6} lg={4}>
            <input
              type="text"
              placeholder="Search by email"
              className="input input-bordered search-input-white focus:ring-0 focus:outline-none border-[#E6ECF2] font-normal text-14 text-muted w-full"
              onChange={handleSearch}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={8} sx={{ display: 'flex', justifyContent: 'flex-start', gap: '10px' }}>
            <GradientButton
              color="red"
              width="150px"
              height="40px"
              onClick={() => setShowImportModal(true)}
            >
              <HugeiconsIcon
                icon={Upload04Icon}
                size={20}
                color="#fff"
                stroke="0.2"
              />
              <span className="ml-[5px]">Import</span>
            </GradientButton>

            <OutlineButton
              type="rounded"
              color="gray"
              width="150px"
              height="40px"
              onClick={() => setShowExportModal(true)}
            >
              <HugeiconsIcon
                icon={Download04Icon}
                size={20}
                color="#3a3a3a"
                stroke="0.2"
              />
              <span className="ml-[5px]">Export</span>
            </OutlineButton>
          </Grid>
        </Grid>
      </div>

      <div className='data-table-container mb-10 te-table-container'>
        <CustomDataTable
          columns={columns}
          data={unsubscribeSearchData}
          pagination
          progressPending={loading}
        />
      </div>

      <MUIModal title={"Delete Email"} openModal={showDeleteUnsubscribeModal} closeModal={handleDeleteUnsubscribeClose} width={'50%'}>

        <div className="px-[16px] pt-[10px] pb-[30px]">
          <p className="text-14 text-muted">{ARE_YOU_SURE} delete the email{" "}<span className="font-semibold">{unsubscribeEmailData?.emailAddress}</span> from unsubscribe list?</p>

          <TextareaAutosize
            minRows={3}
            placeholder="Enter your comment"
            value={submitmessage}
            onChange={(e) => {
              setSubmitMessage(e.target.value);
              setValidationError('');
              setWarningMessage('');
            }}
            className="w-full border rounded-md p-2 mt-2"
            style={{
              borderColor: validationError ? 'red' : '#ccc',
              fontSize: '14px'
            }}
          />

          {validationError && (
            <div className="flex text-primary mt-2 text-md">
              <img src="/assets/images/attention.svg" alt="Error" width={12} height={12} className="mr-1" />
              {validationError}
            </div>
          )}

          {warningMessage && (
            <div className="flex text-primary mt-2 text-md">
              <img src="/assets/images/attention.svg" alt="Warning" width={12} height={12} className="mr-1" />
              {warningMessage}
            </div>
          )}
        </div>

        <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
          <div className="w-full relative col-span-3">
            <button
              type="button"
              className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg-[#f0f0f0] disabled:text-muted"
              onClick={handleDeleteUnsubscribeClose}
            >
              {LABEL_BTN_CANCEL}
            </button>
          </div>

          <div className="w-full relative col-span-3">
            <button
              type="button"
              // eslint-disable-next-line @typescript-eslint/no-misused-promises
              onClick={handleDeleteUnsubscribeConfirm}
              className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]"
            >
              {!isModalLoading ? "Delete" : (<span className="loading loading-spinner loading-xs text-white"></span>)}
            </button>
          </div>
        </div>

      </MUIModal>
      {/* Import Modal */}
      <MUIModal
        title={"Import Unsubscribe List"}
        openModal={showImportModal}
        closeModal={() => { setShowImportModal(false); resetImportState(); }}
        width={'50%'}
      >
        <div className="px-[16px] pt-[10px] pb-[70px]">
          <Box sx={{ mb: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
              <FormLabel sx={{ fontWeight: 'semibold', color: 'text.primary' }}>Select Unsubscribe Type</FormLabel>
            </Box>

            <RadioGroup row value={importScope} onChange={(e) => handleImportScopeChange(e.target.value)} sx={{ mb: 2 }}>
              {BULK_UNSUBSCRIBE_LEVELS.map((level) => (
                <FormControlLabel key={level.value} value={level.label} control={<Radio />} label={level.label} />
              ))}
            </RadioGroup>

            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Box sx={{ order: importScope === 'Campaign' ? 2 : 1, width: '100%' }}>
                {/* EmailType Dropdown — always visible */}
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <Autocomplete
                    options={[
                      { label: 'Trigger Campaign', value: 'TriggerRequest' },
                      { label: 'Bulk Campaign', value: 'BulkCampaign' }
                    ]}
                    getOptionLabel={(option) => option.label}
                    popupIcon={<HugeiconsIcon icon={ArrowDown01Icon} size={18} color="#3A3A3A" strokeWidth={0.2} />}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    value={[{ label: 'Trigger Campaign', value: 'TriggerRequest' }, { label: 'Bulk Campaign', value: 'BulkCampaign' }].find(opt => opt.value === importEmailType) ?? null}
                    onChange={(_, selectedOption) => handleImportEmailTypeChange(selectedOption?.value ?? '')}
                    renderInput={(params) => (
                      <TextField {...params} label="Email Type" />
                    )}
                  />
                </FormControl>
              </Box>

              {(!user?.isClientRole && (importScope === 'Client' || importScope === 'Campaign')) && (
                <Box sx={{ order: importScope === 'Campaign' ? 1 : 2, width: '100%' }}>
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <Autocomplete
                      options={clients}
                      getOptionLabel={(option) => option.clientName || ''}
                      popupIcon={<HugeiconsIcon icon={ArrowDown01Icon} size={18} color="#3A3A3A" strokeWidth={0.2} />}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      value={clients.find(client => client.id === selectedImportClient) ?? null}
                      onChange={(_, selectedOption) => {
                        setSelectedImportClient(selectedOption?.id ?? '');
                        setSelectedImportCampaign(''); // Reset campaign when client changes
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Client" />
                      )}
                    />
                  </FormControl>
                </Box>
              )}

              {importScope === 'Campaign' && (
                <Box sx={{ order: 3, width: '100%' }}>
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <Autocomplete
                      options={importCampaigns}
                      getOptionLabel={(option) => option.name || ''}
                      popupIcon={<HugeiconsIcon icon={ArrowDown01Icon} size={18} color="#3A3A3A" strokeWidth={0.2} />}
                      isOptionEqualToValue={(option, value) => option.campaignId === value.campaignId}
                      value={importCampaigns.find(camp => camp.campaignId === selectedImportCampaign) ?? null}
                      onChange={(_, selectedOption) => setSelectedImportCampaign(selectedOption?.campaignId ?? '')}
                      renderInput={(params) => (
                        <TextField {...params} label="Campaign" />
                      )}
                    />
                  </FormControl>
                </Box>
              )}
            </Box>

            <Box sx={{ mt: 2 }}>
              {importFile ? (
                <div key={importFile.name} className="dropzone">
                  <span className="font-semibold">{importFile.name}</span>
                  <a
                    href="javascript:void(0)"
                    onClick={handleRemoveFile}
                    style={{ color: "red", paddingTop: "10px", marginLeft: "10px" }}
                  >
                    Remove
                  </a>
                </div>
              ) : (
                <div {...getRootProps({ className: "dropzone" })}>
                  <input {...getInputProps()} />
                  {isDragActive ? (
                    <p>Drop the files here ...</p>
                  ) : (
                    <>
                      <p>
                        <strong className="font-semibold">Drag and drop or</strong>
                        <span style={{ color: "#d6242c", cursor: "pointer", fontWeight: "600" }}>
                          {" "}Click here{" "}
                        </span>
                        <strong className="font-semibold">to choose file.</strong>
                      </p>
                      <span
                        style={{
                          display: "block",
                          marginTop: "20px",
                          fontSize: "14px",
                          color: "#3A3A3A",
                        }}
                      >
                        {mbValue > 0 && `Max size ${mbValue} MB . `} File format: CSV
                      </span>
                      <span
                        style={{
                          display: "block",
                          marginTop: "5px",
                          fontSize: "14px",
                          color: "#3A3A3A",
                        }}
                      >
                        <a
                          href="/assets/import-export-file/Sample.csv"
                          download="sample.csv"
                          onClick={(e) => e.stopPropagation()}
                          style={{
                            color: "#d6242c",
                            textDecoration: "underline",
                            fontWeight: 600,
                          }}
                        >
                          Download
                        </a>{" "}
                        a sample CSV template
                      </span>
                    </>
                  )}
                </div>
              )}
            </Box>

            {importErrorSummary && (
              <Box sx={{ mt: 2, p: 2, bgcolor: '#FFF4F4', borderRadius: 1, border: '1px solid #FFCACA' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <HugeiconsIcon
                    icon={Alert02StrokeStandard}
                    size={20}
                    color="#D32F2F"
                    strokeWidth={0.5}
                  />
                  <FormLabel sx={{ ml: 1, color: '#D32F2F', fontWeight: 'bold' }}>{importErrorSummary}</FormLabel>
                </Box>
                <Box sx={{ maxHeight: '150px', overflowY: 'auto' }}>
                  {importErrorDetails.map((err, idx) => (
                    <Box key={idx} sx={{ fontSize: '12px', color: '#666', mb: 0.5 }}>
                      Row {err.row}: {err.reason ?? 'Invalid data'}
                    </Box>
                  ))}
                </Box>
              </Box>
            )}
          </Box>
        </div>

        <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
          <div className="w-full relative col-span-3">
            <button
              type="button"
              className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg-[#f0f0f0] disabled:text-muted"
              onClick={() => { setShowImportModal(false); resetImportState(); }}
            >
              Cancel
            </button>
          </div>

          <div className="w-full relative col-span-3">
            <button
              type="button"
              onClick={() => { void handleImport(); }}
              className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]"
            >
              {isImportLoading ? <span className="loading loading-spinner loading-xs text-white"></span> : "Import"}
            </button>
          </div>
        </div>
      </MUIModal>

      {/* Export Modal */}
      <MUIModal
        title={"Export Unsubscribe List"}
        openModal={showExportModal}
        closeModal={() => { setShowExportModal(false); resetExportState(); }}
        width={'50%'}
      >
        <div className="px-[16px] pt-[10px] pb-[70px]">
          <Box sx={{ mb: 2 }}>
            <FormLabel sx={{ fontWeight: 'semibold', color: 'text.primary', display: 'block', mb: 1 }}>Select Unsubscribe Type</FormLabel>
            <RadioGroup row value={exportScope} onChange={(e) => handleExportScopeChange(e.target.value)} sx={{ mb: 2 }}>
              {BULK_UNSUBSCRIBE_LEVELS.map((level) => (
                <FormControlLabel key={level.value} value={level.label} control={<Radio />} label={level.label} />
              ))}
            </RadioGroup>

            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Box sx={{ order: exportScope === 'Campaign' ? 2 : 1, width: '100%' }}>
                {/* EmailType Dropdown — always visible */}
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <Autocomplete
                    options={[
                      { label: 'Trigger Campaign', value: 'TriggerRequest' },
                      { label: 'Bulk Campaign', value: 'BulkCampaign' }
                    ]}
                    getOptionLabel={(option) => option.label}
                    popupIcon={<HugeiconsIcon icon={ArrowDown01Icon} size={18} color="#3A3A3A" strokeWidth={0.2} />}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    value={[{ label: 'Trigger Campaign', value: 'TriggerRequest' }, { label: 'Bulk Campaign', value: 'BulkCampaign' }].find(opt => opt.value === exportEmailType) ?? null}
                    onChange={(_, selectedOption) => handleExportEmailTypeChange(selectedOption?.value ?? '')}
                    renderInput={(params) => (
                      <TextField {...params} label="Email Type" />
                    )}
                  />
                </FormControl>
              </Box>

              {(!user?.isClientRole && (exportScope === 'Client' || exportScope === 'Campaign')) && (
                <Box sx={{ order: exportScope === 'Campaign' ? 1 : 2, width: '100%' }}>
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <Autocomplete
                      options={clients}
                      getOptionLabel={(option) => option.clientName || ''}
                      popupIcon={<HugeiconsIcon icon={ArrowDown01Icon} size={18} color="#3A3A3A" strokeWidth={0.2} />}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      value={clients.find(client => client.id === selectedExportClient) ?? null}
                      onChange={(_, selectedOption) => {
                        setSelectedExportClient(selectedOption?.id ?? '');
                        setSelectedExportCampaign(''); // Reset campaign when client changes
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Client" />
                      )}
                    />
                  </FormControl>
                </Box>
              )}

              {exportScope === 'Campaign' && (
                <Box sx={{ order: 3, width: '100%' }}>
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <Autocomplete
                      options={exportCampaigns}
                      getOptionLabel={(option) => option.name || ''}
                      popupIcon={<HugeiconsIcon icon={ArrowDown01Icon} size={18} color="#3A3A3A" strokeWidth={0.2} />}
                      isOptionEqualToValue={(option, value) => option.campaignId === value.campaignId}
                      value={exportCampaigns.find(camp => camp.campaignId === selectedExportCampaign) ?? null}
                      onChange={(_, selectedOption) => setSelectedExportCampaign(selectedOption?.campaignId ?? '')}
                      renderInput={(params) => (
                        <TextField {...params} label="Campaign" />
                      )}
                    />
                  </FormControl>
                </Box>
              )}
            </Box>
          </Box>
        </div>

        <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
          <div className="w-full relative col-span-3">
            <button
              type="button"
              className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg-[#f0f0f0] disabled:text-muted"
              onClick={() => { setShowExportModal(false); resetExportState(); }}
            >
              Cancel
            </button>
          </div>

          <div className="w-full relative col-span-3">
            <button
              type="button"
              onClick={() => { void handleExport(); }}
              className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]"
            >
              {isExportLoading ? <span className="loading loading-spinner loading-xs text-white"></span> : "Export"}
            </button>
          </div>
        </div>
      </MUIModal>
    </>
  );
};

export default UnSubscribeList;

